import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import * as GoogleMapsLoader from 'google-maps';
import { Address } from './address.model';
import { environment } from '../../../environments/environment';

@Injectable()
export class AddressValidationService {

  constructor(private http: Http) { }

  public getAddressSuggestionGoogle(query: string, language: string): Observable<Address> {
    return Observable.create(observer => {
      GoogleMapsLoader.KEY = environment.locatorsSearchEngineOptions.key;
      GoogleMapsLoader.LIBRARIES = ['places'];
      GoogleMapsLoader.load((google) => {
        const service = new google.maps.places.AutocompleteService();
        const placeService = new google.maps.places.PlacesService(document.createElement('div'));
        service.getQueryPredictions({
          input: query,
          types: ['geocode']
        }, (x) => {
          if (x && x.length > 0) {
            const request = {'placeId': x[0].place_id};

            placeService.getDetails(request, (y) => {
              observer.next(this.addressFromGoogle(y));
              observer.complete();
            });
          } else {
            observer.error('No result');
          }
        });
      });
    });
  }

  addressFromGoogle(place: any): Address {
    console.log('addressFromGoogle', place);
    const componentForm = {
      street_number: 'short_name',
      route: 'long_name',
      locality: 'long_name',
      administrative_area_level_1: 'long_name',
      country: 'long_name',
      postal_code: 'short_name',
      sublocality_level_1: 'long_name'
    };

    const components = {
      street_number: '',
      route: '',
      locality: '',
      administrative_area_level_1_short: '',
      administrative_area_level_1_long: '',
      country_short: '',
      country_long: '',
      postal_code: '',
      sublocality_level_1: ''
    };

    // Get each component of the address from the place details
    // and fill the corresponding field on the form.
    for (let i = 0; i < place.address_components.length; i++) {
      const addressType = place.address_components[i].types[0];
      if (componentForm[addressType]) {
        if (addressType === 'administrative_area_level_1' || addressType === 'country') {
          components[addressType + '_short'] = place.address_components[i]['short_name'];
          components[addressType + '_long'] = place.address_components[i]['long_name'];
        } else {
          const val = place.address_components[i][componentForm[addressType]];
          components[addressType] = val;
        }
      }
    }

    let boroughCode = '';
    if (components.sublocality_level_1) {
      const borough = environment.arrondissements.find((x) => x.gname === components.sublocality_level_1);
      if (borough) {
        boroughCode = borough.code;
      }
    }
    return <Address>{
      addressLine1: `${components.street_number} ${components.route}`,
      city: components.locality,
      region: {
        code: components.administrative_area_level_1_short,
        name: components.administrative_area_level_1_long
      },
      country: {
        code: components.country_short,
        name: components.country_long
      },
      postalCode: components.postal_code,
      borough: boroughCode
    };
  }

}



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/shared/address-validation/address-validation.service.ts